import strings from "@/resources/strings";
import isFQDN from "validator/lib/isFQDN";

const minimumPasswordLength = 15;

export default {
  minimumPasswordLength,
  url(rule, value, callback) {
    const pattern =
      /^[a-zA-Z0-9.-]{1,256}\.[a-z]{2,6}\b(?:[-a-zA-Z0-9@:%_+.~#?&/=]*)$/;
    if (!pattern.test(value)) {
      callback(Error("Invalid address, e.g. sub.example.com."));
      return;
    }
    callback();
  },
  fqdn(rule, value, callback) {
    if (!isFQDN(value)) {
      callback(Error("Invalid fqdn, e.g. sub.example.com."));
      return;
    }
    callback();
  },
  validatePassword(rule, value, callback) {
    const passwordValid = value.length >= minimumPasswordLength;
    if (!passwordValid) {
      callback(new Error(strings.password_too_short));
      return;
    }
    callback();
  },
  UriType: {
    Radio: "radio_id",
    Phone: "phone_no",
    PABX: "pabx_no",
    Wildcard: "basic_wildcard_number",
    WildcardPhone: "wildcard_phone_no",
  },
  validateURI(uri, uriType, callback) {
    switch (uriType) {
      case this.UriType.Radio:
        if (uri.length > 255) {
          callback(new Error("Address may be at most 255 characters long."));
          return;
        }
        if (!/^[1-9][0-9]*$/.test(uri)) {
          callback(
            new Error(
              "Invalid radio ID. Example: '1234' with no leading zero.",
            ),
          );
          return;
        }
        break;
      case this.UriType.Phone:
        if (uri.replace(/^\+/, "").length > 255) {
          callback(new Error("Address may be at most 255 characters long."));
          return;
        }
        if (!/^[+]?[0-9-.() ]+$/.test(uri) || !/[0-9]+/.test(uri)) {
          callback(
            new Error(
              "Must contain at least one number 0-9. May contain +, -, ., (, ) or spaces.",
            ),
          );
          return;
        }
        break;
      case this.UriType.PABX:
        if (uri.length > 255) {
          callback(new Error("Address may be at most 255 characters long."));
          return;
        }
        if (!/^[0-9]+$/.test(uri)) {
          callback(new Error("Must contain at least one number 0-9."));
          return;
        }
        break;
      case this.UriType.Wildcard:
        if (!/^(\d+|\d*\*)$/.test(uri)) {
          callback(
            new Error(
              "Must contain a number that may end with the * character. The * character can also be used on its own.",
            ),
          );
          return;
        }
        break;
      case this.UriType.WildcardPhone:
        if (
          !/^(\+?[\d\-.() ]+|\+?[\d\-.() ]*\*)$/.test(uri) ||
          !/[0-9]+|\*/.test(uri)
        ) {
          callback(
            new Error(
              "Must contain a number that may end with the * character and contain +, -, ., (, ) or spaces. The * character can also be used on its own.",
            ),
          );
          return;
        }
        break;
      default:
        callback(new Error("Unknown URI type"));
        return;
    }
    callback();
  },
  validateWildcard(thisUri, otherUri, callback) {
    if (
      thisUri &&
      otherUri &&
      ((thisUri.includes("*") && !otherUri.includes("*") && otherUri != "") ||
        (otherUri.includes("*") && !thisUri.includes("*")))
    ) {
      callback(
        new Error("* character must be used in both inputs or neither."),
      );
      return;
    }
    callback();
  },
  validatePemFile(pemText, prefix, postfix, callback) {
    const pemCoreRegex = "(?:\r|\n|\r\n)[\n\r0-9a-zA-Z+/=]+(?:\r|\n|\r\n)";
    let pemRegex = new RegExp(`${prefix}${pemCoreRegex}${postfix}`);
    callback(pemText === "" || pemText.match(pemRegex));
  },
  validateIp(rule, value, callback) {
    const pattern =
      /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    if (!pattern.test(value)) {
      callback(Error("Invalid IPv4 address"));
      return;
    }
    callback();
  },
};
